
import { defineComponent, onMounted, ref } from 'vue';
import { useCookies } from 'vue3-cookies';
import router from './router';

export default defineComponent({
  name: 'Home',
  components: {
    
  },

  watch: {
    '$route': function (to, from) {
      if (to.path !== from.path) {
        this.setLogin()
      }
    }
  },

  setup(){
    const cookies  = useCookies();

    const visible = ref(false)
    const isLogin = ref(true)
    const isPhamacy = ref(false)

    onMounted(()=>{
      setLogin()
    })

    const LogOutView = () => {
      visible.value = true
    }

    const LogOut = () => {
      cookies.cookies.remove('token');
      cookies.cookies.remove('pharmacy');
      visible.value = false
      isLogin.value = false
      isPhamacy.value = false
      router.push("/login")
    }

    const setLogin = () => {
      var token = cookies.cookies.get('token');
      isLogin.value = token != null

      if(cookies.cookies.isKey('pharmacy')){
        isPhamacy.value = cookies.cookies.isKey('pharmacy')
      } 
    }

    return {
      visible,
      LogOutView,
      LogOut,
      isLogin,
      isPhamacy,
      setLogin,
    }
  }
});
